export const getMultiCouponDialogContentStyles = () => ({
  couponContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  optionText: {
    display: 'flex',
    flexDirection: 'row',
  },
  couponWarningDetails: {
    fontStyle: 'normal',
    paddingBottom: 10,
  },
  optionTypeText: {
    fontWeight: 'bold',
    marginRight: 4,
  },
  optionRoot: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  choiceGroup: {
    '& .ms-ChoiceFieldGroup-flexContainer': {
      '& .ms-ChoiceField-wrapper': {
        width: '100%',
        '& .ms-ChoiceField-field': {
          paddingTop: 0,
          marginTop: 5,
        },
      },
      '& .ms-TextField': {
        paddingLeft: 24,
        paddingBottom: 8,
      },
    },
  },
  confirmDialogOverride: {
    '& div': {
      marginBottom: '0 !important',
    },
  },
});
